import { useState } from "react";
import useBrands from "../../../../explorer/hooks/useBrands";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { TextField, Typography } from "@mui/material";
import { TypographyPonMessageStyled, TypographyPonTitleStyled } from "./OfferOrderReference.style";
import { useFormClasses } from "./CreateOfferOrderForm.style";



var timeout: NodeJS.Timeout | undefined = undefined;

type BasketOfferOrderReferenceProps = {
  isOffer: boolean;
  value: string;
  offerReferenceValid: boolean;
  onChange: any;
  onChangeOfferReferenceValid: (value: boolean) => void;
};

export const OfferOrderReference: React.FC<BasketOfferOrderReferenceProps> = (
  props
) => {
  
   
  const { t } = useTranslation();
  const brand = useBrands().currentBrandUrl;
  const classes = useFormClasses();
  
  async function checkReferenceValue(refValue: string) {
    const result: any = await ServiceProvider.OrderOffer.checkOrderOfferReference(brand, props.isOffer ? "offer" : "order",refValue);
      setCheckMessage(result);
      props.onChangeOfferReferenceValid(result);
    
  }

  const [checkMessage, setCheckMessage] = useState<boolean | null>(null);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChangeOfferReferenceValid(false);
    props.onChange(event);
    if (event.target.value == "") {
      if (timeout != undefined) clearTimeout(timeout);
      setCheckMessage(null);
    } else {
      if (timeout != undefined) clearTimeout(timeout);
      var tmpVal = event.target.value;
      timeout = setTimeout(function() {
        checkReferenceValue(tmpVal);
      }, 300);
    }
  };

  return (
      <>
          <Typography sx={classes.title}>
              {props.isOffer
                  ? t("offer.cust_purch_on")
                  : t("order.cust_purch_on")}
          </Typography>
          <TextField
              margin="none"
              id="customer-order-reference"
              variant="standard"
              hiddenLabel
             
              placeholder={
                  props.isOffer
                      ? t("offer.cust_purch_offer_ref_placeholder")
                      : t("order.cust_purch_order_ref_placeholder")
              }
              fullWidth
              //inputProps={{ className: classes.input }}
              //InputLabelProps={{ shrink: true, className: classes.title }}    }}  input : {{classes.input }}
              slotProps={
                  {
                      //inputLabel: { shrink: true, sx: classes.title },
                        input: { sx: classes.input },
                  }
              }
              // InputProps={{classes: { root: classes.root, input: classes.input },//disableUnderline: true,}}
              onChange={handleChange}
              value={props.value}
          />
          <div style={{ marginBottom: "5px" }}>
              <TypographyPonMessageStyled
                  isvalid={checkMessage !== null ? ''+checkMessage : 'true'}
                  variant="body2"
                  color="error"
              >
                  {checkMessage !== null ? (
                      checkMessage ? (
                          props.isOffer ? (
                              t("offer.pon_valid")
                          ) : (
                              t("order.pon_valid")
                          )
                      ) : props.isOffer ? (
                          t("offer.pon_not_valid")
                      ) : (
                          t("order.pon_not_valid")
                      )
                  ) : (
                      <span></span>
                  )}
              </TypographyPonMessageStyled>
          </div>
      </>
  );
};

